import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setServiceType } from "../../redux/features/customer/customerSlice";
import { clearAllCateringData } from "../../redux/features/restaurants/restaurantSlice";
import { clearAllCateringCustomerData } from "../../redux/features/cateringCustomer/cateringCustomerSlice";
import { clearCompanyDataExceptList } from "../../redux/features/company/companySlice";

export const CateringPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleIndividual = () => {
        // Always clear all catering data (cart, filters, etc.) when selecting individual catering
        // This ensures fresh start whether coming from main screen or re-clicking same button
        dispatch(clearAllCateringData());
        
        // Always clear company data when selecting individual catering
        dispatch(clearCompanyDataExceptList());
        
        dispatch(setServiceType("individual catering"));
        navigate("/catering-order");
    };

    const handleCorporate = () => {
        // Always clear all catering data (cart, filters, etc.) when selecting corporate catering
        // This ensures fresh start whether coming from main screen or re-clicking same button
        dispatch(clearAllCateringData());
        
        // Always clear individual catering customer data when selecting corporate catering
        dispatch(clearAllCateringCustomerData());
        
        dispatch(setServiceType("corporate catering"));
        navigate("/catering-order");
    };

    const handleViewCalendar = () => {
        navigate("/catering-calendar");
    };

    return (
        <div className="flex justify-center items-center min-h-screen -mt-20">
            <div className="flex flex-col items-center gap-6">
                <div className="flex flex-row gap-8">
                    {/* Individual Catering Button */}
                    <button
                        className="w-[257px] h-[162px] bg-gradient-to-br from-[#86604D] to-[#6B4A3A] rounded-xl flex flex-col items-center justify-center text-white font-bold text-2xl shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-105 group"
                        onClick={handleIndividual}
                    >
                        <svg 
                            className="w-16 h-16 mb-3 transition-transform duration-300 group-hover:scale-110" 
                            fill="currentColor" 
                            viewBox="0 0 20 20"
                        >
                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                        </svg>
                        <span>Individual</span>
                    </button>

                    {/* Corporate Catering Button */}
                    <button
                        className="w-[257px] h-[162px] bg-gradient-to-br from-[#86604D] to-[#6B4A3A] rounded-xl flex flex-col items-center justify-center text-white font-bold text-2xl shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-105 group"
                        onClick={handleCorporate}
                    >
                        <svg 
                            className="w-16 h-16 mb-3 transition-transform duration-300 group-hover:scale-110" 
                            fill="currentColor" 
                            viewBox="0 0 20 20"
                        >
                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
                        </svg>
                        <span>Corporate</span>
                    </button>
                </div>

                {/* View Catering Events Button */}
                <button
                    className="w-[542px] h-[56px] bg-gradient-to-r from-[#86604D] to-[#6B4A3A] rounded-xl flex items-center justify-center gap-3 text-white font-bold text-xl shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-105 group"
                    onClick={handleViewCalendar}
                >
                    <svg 
                        className="w-6 h-6 transition-transform duration-300 group-hover:scale-110" 
                        fill="currentColor" 
                        viewBox="0 0 20 20"
                    >
                        <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                    </svg>
                    <span>View Catering Events</span>
                </button>
            </div>
        </div>
    );
};
